module.exports = function () {
    return function (array, value) {
        return array.indexOf(value) !== -1;
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/filters/in-array.js
 **/